export function joinLatLong(
  latitude: Nullable<string>,
  longitude: Nullable<string>,
) {
  return latitude && longitude ? [latitude, longitude].join(',') : null;
}

export function splitLatLong(latLong: Nullable<string>): {
  latitude: Nullable<string>;
  longitude: Nullable<string>;
} {
  const [latitude, longitude] = latLong?.toString().split(',') ?? [];
  return {
    latitude,
    longitude,
  };
}
